// To migrate a new property to redux, you should create a key-value number and set this to the persistConfig version.
const migrations = {
  0: state => {
    return {
      ...state,
      system: { ...state.system, internalRingtone: 'classicvibes' },
    };
  },
  1: state => {
    return {
      ...state,
      system: { ...state.system, userPreferences: { audio: {} } },
    };
  },
  2: state => {
    return {
      ...state,
      system: { ...state.system, temporaryISOCode: null },
    };
  },
  3: state => {
    return {
      ...state,
      system: { ...state.system, disableKeypadTone: false },
    };
  },
};

export default migrations;
